export default "__VITE_PUBLIC_ASSET__b82de0c4__"